import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box, Grid, IconButton, Stack } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";

const ContactUs = () => {
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "column",
            boxShadow: "#dad2cb 12px 12px 24px",
            border: "2px solid black",
            borderRadius: '25px',
            width: "40rem",
            padding: "0.5rem",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "1000" }}>
            S R Classes
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "25px", fontWeight: "1000", mt: 2 }}
          >
            Near SVM Sultanpur
          </Typography>
          <img
            src="/Images/ravi-sir.jpg"
            alt="hero-section"
            style={{
              height: 300,
              width: 300,
              objectFit: "cover",
              borderRadius: "50%",
              marginTop: "20px",
            }}
          />
          <Typography
            variant="body1"
            sx={{ fontWeight: "1000", fontSize: "20px", mt: 2 }}
          >
            Admision Open
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: "1000", fontSize: "20px", mt: 2 }}
          >
            Contact +91 82996 65230
          </Typography>
          <div
            style={{
              // border: '2px solid red',
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
              marginTop: "20px",
            }}
          >
            <a href="tel:+918299665230">
              <IconButton
                sx={{
                  border: "2px solid black",
                  height: "80px",
                  width: "80px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                  <CallIcon sx={{ fontSize: "40px" }} />
                </Typography>
              </IconButton>
            </a>
            <a href="https://wa.me/+918299665230">
              <IconButton
                sx={{
                  border: "2px solid black",
                  height: "80px",
                  width: "80px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                  <WhatsAppIcon sx={{ fontSize: "40px" }} />
                </Typography>
              </IconButton>
            </a>
          </div>
          <Typography
            variant="body1"
            className="footer-main2"
            sx={{
              marginTop: "0px",
              "@media (max-width: 400px)": {
                fontSize: "0.8rem",
              },
              fontWeight: "800",
              padding: "10px",
            }}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <HomeIcon /> */}
                <span>
                  Shastri Nagar Near SVM <br /> Sultanpur, 228001
                </span>
              </div>
              <div
                style={{
                  fontWeight: "800",
                  fontSize: "0.8rem",
                  color: "rgb(129 129 129)",
                }}
              >
                Since 2014
              </div>
            </Stack>
          </Typography>
        </Grid>
      </Box>
    </Container>
  );
};

export default ContactUs;
